module.exports = __webpack_public_path__ + "img/icon_5.df4475c.svg";